// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

.content {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.content app-settings {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/settings-widget/settings-widget.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AACF;;AAEA;EACE,OAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AACF;AACE;EACE,OAAA;EACA,aAAA;EACA,gBAAA;AACJ","sourcesContent":[":host {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0; // Critical for flex containers to shrink\n  overflow: hidden;\n}\n\n.content {\n  flex: 1;\n  min-height: 0; // Critical for flex children to shrink and scroll\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n\n  app-settings {\n    flex: 1;\n    min-height: 0; // Critical for flex children to scroll\n    overflow-y: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
